import { Toast } from 'antd-mobile';
export default {
    // 生成n位的随机数
    RndNum(n: any) {
        var rnd = "";
        for (var i = 0; i < n; i++) {
            rnd += Math.floor(Math.random() * 10);
        }
        return rnd
    },

    // 格式化手机号-去空格
    trim(str: any, is_global: any) {
        let result;
        result = str.replace(/(^\s+)|(\s+$)/g, "");
        if (is_global && is_global.toLowerCase() == "g") {

            result = result.replace(/\s/g, "");

        }
        return result;
    },
    // 密码为6-18位的数字和字母的组合
    verifyPassWordEighteen(pwd: any) {
        let result;
        let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/;
        result = reg.test(pwd)
        return result
    },
    // 密码为6-20位的数字和字母的组合
    verifyPassWord(pwd: any) {
        let result;
        let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
        result = reg.test(pwd)
        return result
    },

    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X 
    isCardNo(card: any) {
        let result;

        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        result = reg.test(card)

        return result
    },

    // 银行卡校验
    isBankCard(card: any) {
        let result;
        
        // let reg = /^(\\d{13}|\\d{19})$/ (13或者19位)
        let reg = /(^[1-9]\d*$)/
        result = reg.test(card)

        return result
    },

    // 通过身份证号计算年龄、性别、出生日期
    getIdCardInfo(userCard: any) {

        let birth = '';
        // 获取出生日期
        birth = userCard.substring(6, 10) + "-" + userCard.substring(10, 12) + "-" + userCard.substring(12, 14);

        let sex;
        // 获取性别
        if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
            sex = 1;
        } else {
            sex = 2;
        }

        let age;
        // 获取年龄
        let myDate = new Date();
        let month = myDate.getMonth() + 1;
        let day = myDate.getDate();
        age = myDate.getFullYear() - userCard.substring(6, 10) - 1;
        if (userCard.substring(10, 12) < month || (userCard.substring(10, 12) == month && userCard.substring(12, 14) <= day)) {
            age++;
        }

        return {
            birth,
            sex,
            age
        }
    },

    // 通过出生日期计算出年龄YYYY(-、/)MM(-、/)DD
    getAgeByBirth(birth: any) {
        if (birth.indexOf('-') > 0) {
            birth = birth.replace(/-/g, '');
        }
        if (birth.indexOf('/') > 0) {
            birth = birth.replace(/\//g, '');
        }
        let age;
        let myDate = new Date();
        let month = myDate.getMonth() + 1;
        let day = myDate.getDate();
        age = myDate.getFullYear() - birth.substring(0, 4) - 1;
        let birthMonth = birth.substring(4, 6);
        let birthDay = birth.substring(6, 8);
        if (birthMonth < month || (birthMonth == month && birthDay <= day)) {
            age++;
        }
        return age;
    }
}